// After Sales Select2 Helper
// This ensures all select2 elements are properly initialized with Turbolinks

// Wait for document ready
document.addEventListener('DOMContentLoaded', initializeAllSelect2Elements);
// Also run when Turbolinks loads a new page
document.addEventListener('turbolinks:load', initializeAllSelect2Elements);

// Main initialization function
function initializeAllSelect2Elements() {
  //console.log('[Select2 Helper] Initializing all select2 elements');
  
  // Check if jQuery and select2 are available
  if (typeof $ === 'undefined' || typeof $.fn.select2 === 'undefined') {
    //console.error('[Select2 Helper] jQuery or Select2 not loaded yet');
    // Try again after a short delay
    setTimeout(initializeAllSelect2Elements, 100);
    return;
  }
  
  // Check if we're on the service job show page
  const currentPath = window.location.pathname;
  const isServiceJobShow = currentPath.includes('/after_sales/service_jobs/') && 
                          !currentPath.includes('/edit') && 
                          !currentPath.includes('/new');
                          
  if (isServiceJobShow) {
    console.log('[Select2 Helper] On service job show page, skipping general initialization');
    return; // Skip initialization on service job show page
  }
  
  // Find all select elements with the select2 class that aren't initialized yet
  $('select.select2:not(.select2-hidden-accessible)').each(function() {
    const $select = $(this);
    const selectId = $select.attr('id');
    
    // Skip elements that are managed by the service job show page
    if (selectId === 'labor_id' || selectId === 'storage_location_id' || 
        selectId === 'part_id' || 
        $select.hasClass('labor-select') || $select.hasClass('location-select') || 
        $select.hasClass('part-select') || $select.hasClass('technician-select')) {
      console.log('[Select2 Helper] Skipping element managed by service job show page:', selectId || $select.attr('name'));
      return;
    }
    
    // Check for data attributes that configure the select2
    const minimumInputLength = $select.data('minimum-input-length') || 0;
    const placeholder = $select.data('placeholder') || 'Select an option...';
    const allowClear = $select.data('allow-clear') !== false;
    const ajaxUrl = $select.data('ajax-url');
    
    // Basic config
    const config = {
      width: '100%',
      placeholder: placeholder,
      allowClear: allowClear
    };
    
    // Add minimum input length if specified
    if (minimumInputLength > 0) {
      config.minimumInputLength = minimumInputLength;
    }
    
    // Add ajax configuration if URL is provided
    if (ajaxUrl) {
      config.ajax = {
        url: ajaxUrl,
        dataType: 'json',
        delay: 250,
        data: function(params) {
          return { term: params.term };
        },
        processResults: function(data) {
          return { results: data };
        },
        cache: true
      };
    }
    
    // Initialize select2
    try {
      $select.select2(config);
      
      // Check for pre-selected option from data attributes
      const selectedId = $select.data('selected-id');
      const selectedText = $select.data('selected-text');
      
      if (selectedId && selectedText) {
        // Create the option and select it
        const option = new Option(selectedText, selectedId, true, true);
        $select.append(option).trigger('change');
      }
      
      console.log('[Select2 Helper] Initialized select2 for:', $select.attr('id') || $select.attr('name'));
    } catch (e) {
      console.error('[Select2 Helper] Error initializing select2:', e);
    }
  });
}

// Clean up before caching the page
document.addEventListener('turbolinks:before-cache', function() {
  // Be more selective about which select2 instances to destroy
  // Don't destroy instances that are managed by the service_jobs/show.html.erb page
  if (typeof $ !== 'undefined' && typeof $.fn.select2 !== 'undefined') {
    try {
      // Only destroy select2 instances that aren't on the service job show page
      // or that aren't specifically managed by our custom code
      const currentPath = window.location.pathname;
      const isServiceJobShow = currentPath.includes('/after_sales/service_jobs/') && 
                              !currentPath.includes('/edit') && 
                              !currentPath.includes('/new');
      
      if (!isServiceJobShow) {
        // On other pages, we can safely destroy all select2 instances
        $('.select2-hidden-accessible').select2('destroy');
      } else {
        console.log('[Select2 Helper] Skipping select2 destroy on service job show page');
      }
    } catch (e) {
      console.error('[Select2 Helper] Error during select2 cleanup:', e);
    }
  }
});

// Export for use in other files
export { initializeAllSelect2Elements }; 